export const AUTH_HEADER = {
    authorizationHeaderDescription: "Bearer token to be added for authentication.",
    callbackHeaderDescription: "Callback URL authentication key. If Callback URL is passed as part of request then authentication key is also required for it. While calling callback URL, this key will be passed into request header with \"x-api-key\" attribute.",
}

export const baseResponseDescription = {
    status: "Status Code of the response code.",
    message: "Response Message.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    isSuccess: "true if Success and false if failure.",
}

export const baseRequestDescription = {
    documents: "List of Tax Returns in Base64 format.",
    fileURLs: "List of file URLs, which need to be uploaded.",
    correlationId: "A unique identifier Guid that is attached with the request.",
}

export const baseErrorResponseDescription = {
    errorCode: "Type of error i.e. BadRequest, InternalError etc.",
    message: "Response Message.",
}

/* LOGIN APIs */
export const LOGIN_API_Descriptions = {
    email: 'Email address of the user account',
    password: "Password of the user account",

    accessToken: "Authentication Token.",
    expiresIn: "Expires On period for the generated authentication token.",
    tokenType: "Type of the generated authentication token.",
    refreshToken: "Refresh token to refresh the current session.",
}

/* SIG */
export const commonResponseDescription = {
    ifData: "Data Model (if any).",
}

export const sigBaseRequestBodyDescription = {
    documentId: "Unique Id, to identify the signature.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    callbackUri: "callback endpoint URI to post the actual response.",
    requiredClientGuid: "Client's unique Guid, to whom resend access link should be sent."
}

export const SIG_documentInfoModelDescription = {
    documentId: "Document Id",
    documentName: "Name of the document",
    documentType: "Type of the document.",
    expiresOn: "Document expire on date.",
}

export const SIG_ArchivedSignatures_ArchivedSignaturesDescriptions = {
    clientIdQuery: "ClientId, to identify clients and provided while uploading the signature document.",
    clientNameQuery: "Name of the Client.",
    subjectQuery: "Subject text of the signing email template.",
    sentByQuery: "Name of the CPA user who delivered the signature document.",
    documentNameQuery: "Name of the signature document.",
    documentTypeQuery: "Type of the signature document.",
    taxYearQuery: "Tax year of the signature document. It accepts only current tax year, current (tax year + 1), current (tax year - 1) and current (tax year – 2). By default current tax year filter will be applied on the results.",
    deliveredDateQuery: "It provides all the list of signature documents which delivered from the given date. This field accepts only the date format of MM/DD/YYYY. By default, the results will be sorted based on DeliveredDate field and this field supports only for last 30 days.",
    recipientQuery: "Email address of the recipients.",
    signatureStatusQuery: "Signing status of the delivered signature document.",
    expiryDateQuery: "Date in which the signature document will expire. This field accepts only the date format of MM/DD/YYYY.",
    archivedDateQuery: "It provides all the list of archive signature documents which are archived from the given date. This field accepts only the date format of MM/DD/YYYY and it supports only for last 30 days.",
    lastReminderDateQuery: "Date in which the last reminder for signature document was sent to clients. This field accepts only the date format of MM/DD/YYYY.",
    sortByQuery: "This field is used to sort the results based on the given field. By default, the results will be sorted based on deliveredDate field.",
    sortOrderQuery: "This field is used to sort the results by ascending order or by descending order.",
    pageSizeQuery: "Size of the page to get the given list of signature records. By default, it will set to 10 records.",
    pageNumberQuery: "Page number to get the given page’s list of signature documents. By default, it will be set to 1.",

    clientId: "Client Id",
    clientName: "Name of the client.",
    subject: "Subject",
    sentBy: "User name who sent the report.",
    ...SIG_documentInfoModelDescription,
    taxYear: "Year of tax.",
    recipients: "List of recipients.",
    signatureStatus: "This is SignatureStatus. None=0, Processing=1, OutForDelivery=2, ESigned=3, Declined=4, Cancelled=5, PartiallySigned=6, SignatureStampingFailed=7, DeliveryFailed=8, ManuallySigned = 9, Signed = 10.",
    expiryDate: "Date of expiry for delivered document.",
    lastReminderDate: "Date of last reminder.",
    deliveredDate: "Date of delivered.",
    archivedDate: "Date in which the signature document is archived.",
    locationId: "Unique Id, to identify location details.",
}

export const SIG_ArchivedSignatures_GetAccessLinkDescriptions = {
    documentIdQuery: "Unique Id, to identify the signature.",

    accessLink: "Access link.",
    signerInfoEmailAddress: "Email address of recipient.",
    signerInfoSignedOn: "Date on which document is signed.",
    signerInfoIsSigned: "If true, document is signed.",
    signerInfoClientType: "Client type.",
    signerInfoClientGuid: "Unique id for identifying the client."
}

export const SIG_ArchivedSignatures_SignerDetailsDescriptions = {
    documentIdQuery: "Unique Id, to identify the signature.",

    emailAddress: "Email address of signer.",
    signedOn: "Date on document signed on.",
    isSigned: "Flag - is document signed.",
    clientType: "This is ClientType. Signer = 1, CC = 2, Sender = 3, Delegatee = 4.",
    clientGuid: "Unique guid of client.",
}

export const SIG_ArchivedSignatures_SendReminderDescription = {
    documentId: "Unique Id, to identify the signature.",
    correlationId: "A unique identifier Guid that is attached with the request.",
}

export const SIG_DeliveredAPI_DeliveredSignaturesDescriptions = {
    clientIdQuery: "ClientId, to identify clients and provided while uploading the signature document.",
    clientNameQuery: "Name of the Client.",
    subjectQuery: "Subject text of the signing email template.",
    sentByQuery: "Name of the CPA user who delivered the signature document.",
    documentNameQuery: "Name of the signature document.",
    documentTypeQuery: "Type of the signature document.",
    taxYearQuery: "Tax year of the signature document. It accepts only current tax year, current (tax year + 1), current (tax year - 1) and current (tax year – 2). By default current tax year filter will be applied on the results.",
    deliveredDateQuery: "It provides all the list of signature documents which delivered from the given date. This field accepts only the date format of MM/DD/YYYY. By default, the results will be sorted based on DeliveredDate field and this field supports only for last 30 days.",
    recipientQuery: "Email address of the recipients.",
    signatureStatusQuery: "Signing status of the delivered signature document.",
    expiryDateQuery: "Date in which the signature document will expire. This field accepts only the date format of MM/DD/YYYY.",
    lastReminderDateQuery: "Date in which the last reminder for signature document was sent to clients. This field accepts only the date format of MM/DD/YYYY.",
    sortByQuery: "This field is used to sort the results based on the given field. By default, the results will be sorted based on deliveredDate field.",
    sortOrderQuery: "This field is used to sort the results by ascending order or by descending order.",
    pageSizeQuery: "Size of the page to get the given list of signature records. By default, it will set to 10 records.",
    pageNumberQuery: "Page number to get the given page’s list of signature documents. By default, it will be set to 1.",

    clientId: "Client Id",
    clientName: "Name of the client.",
    subject: "Subject",
    sentBy: "User name who sent the report.",
    ...SIG_documentInfoModelDescription,
    taxYear: "Year of tax.",
    recipients: "List of recipients.",
    signatureStatus: "This is SignatureStatus. None=0, Processing=1, OutForDelivery=2, ESigned=3, Declined=4, Cancelled=5, PartiallySigned=6, SignatureStampingFailed=7, DeliveryFailed=8, ManuallySigned = 9, Signed = 10.",
    expiryDate: "Date of expiry for delivered document.",
    lastReminderDate: "Date of last reminder.",
    deliveredDate: "Date of delivered.",
    locationId: "Unique Id, to identify location details.",
}

export const SIG_DeliveredAPI_SignerDetailsDescriptions = {
    documentIdQueryDescription: "Unique Id, to identify the signature.",
}

export const SIG_DeliveredAPI_AccessLinkDescription = {
    accessLink: "Access link.",
    signerInfoEmailAddress: "Email address of recipient.",
    signerInfoSignedOn: "Date on which document is signed.",
    signerInfoIsSigned: "If true, document is signed.",
    signerInfoClientType: "Client type.",
    signerInfoClientGuid: "Unique id for identifying the client."
}

export const SIG_DraftAPI_DraftSignaturesDescription = {
    nameQuery: "Email address of the recipients.",
    clientIdQuery: "ClientId, to identify clients and provided while uploading the signature document.",
    assignedToQuery: "Name of the user signature assigned to.",
    uploadedAfterDateQuery: "It provides all the list of signature documents which uploaded from the given date. This field accepts only the date format of MM/DD/YYYY. By default, the results will be sorted based on UploadedAfter field, and this field supports only for last 30 days.",
    documentTypeQuery: "Type of the signature document.",
    taxYearQuery: "Tax year of the signature document. It accepts only current tax year, current (tax year + 1), current (tax year - 1) and current (tax year – 2). By default, current tax year filter will be applied on the results.",
    pageSizeQuery: "Size of the page to get the given list of signature records. By default, it will set to 10 records.",
    pageNumberQuery: "Page number to get the given page’s list of signature documents. By default, it will be set to 1.",
    sortOrderQuery: "Pass integer value referred to sort order 0 for ASC, 1 for DESC. By default, sort order will be DESC.",
    sortByQuery: "This field is used to sort the results based on the given field. By default, the results will be sorted based on DocumentStatusChangedOn field.",

    name: "Name of the Client.",
    clientId: "ClientId, to identify clients and provided while uploading the signature document.",
    assignedTo: "Name of the user signature assigned to.",
    SignatureDocumentType: "Type of the signature document.",
    uploadedAfterDate: "Date after which signature document is uploaded.",
    taxYear: "Tax year of the signature document.",
    signatureStatus: "Signing status of the signature document. Available values: None = 0, Processing = 1, OutForDelivery = 2, ESigned = 3, Declined = 4, Cancelled = 5, PartiallySigned = 6, SignatureStampingFailed = 7, DeliveryFailed = 8,  ManuallySigned = 9, Signed = 10, Recalled = 11,Reprocessing = 12.",
    ...SIG_documentInfoModelDescription,
    recipients: "Email address of the recipients.",
    subject: "Subject text of the signing email template.",
    expiryDate: "Date in which the signature document expired.",
    locationId: "Location Id."
}

export const SIG_RecycleBinApi_RecycleBinSignatureDescription = {
    clientNameQuery: "Name of the client.",
    clientIdQuery: "ClientId, to identify clients and provided while uploading the signature document.",
    subjectQuery: "Subject text of the signing email template.",
    documentTypeQuery: "Type of the signature document.",
    taxYearQuery: "Tax year of the signature document. It accepts only current tax year, current (tax year - 1) and current (tax year - 2). By default, current tax year filter will be applied on the results.",
    recipientsQuery: "Email address of the recipients.",
    statusQuery: "Signing status of the signature document. Available values: None = 0, Processing = 1, OutForDelivery = 2, ESigned = 3, Declined = 4, Cancelled = 5, PartiallySigned = 6, SignatureStampingFailed = 7, DeliveryFailed = 8,ManuallySigned = 9, Signed = 10.",
    deletedByQuery: "Name of the user deleted signature.",
    deletionDateQuery: "Date on which signature deleted. This field accepts only the date format of MM/DD/YYYY.",
    sortByQuery: "This field is used to sort the results based on the given field. By default, the results will be sorted based on deletedOn field.",
    sortOrderQuery: "Pass integer value referred to sort order 0 for ASC, 1 for DESC. By default, sort order will be DESC.",
    pageNumberQuery: "Page number to get the given page’s list of organizer documents. By default, it will be set to 1.",
    pageSizeQuery: "Size of the page to get the given list of organizer records. By default, it will set to 10 records.",

    clientName: "Name of the Client.",
    clientId: "ClientId, to identify clients and provided while uploading the signature document.",
    subject: "Subject text of the signing email template.",
    documentType: "Type of the signature document.",
    taxYear: "Tax year of the signature document.",
    deletedBy: "Name of the user deleted signature.",
    signatureStatus: "Signing status of the signature document. Available values: None = 0, Processing = 1, OutForDelivery = 2, ESigned = 3, Declined = 4, Cancelled = 5, PartiallySigned = 6, SignatureStampingFailed = 7, DeliveryFailed = 8, ManuallySigned = 9, Signed = 10..",
    documentInfo: "Document information.",
    recipients: "Email address of the recipients.",
    deletionDate: "Date in which the signature document deleted.",
    locationId: "Unique Id, to identify location details."
}

export const SIG_UploadApi_SendForSignatureDescription = {
    documentName: "Name of the signature document and name should contain .pdf extension in the end. Other file formats are not supported.",
    document: "Signature document to be uploaded in base64 format.",
    clientId: "ClientId, to identify signature document.",
    clientName: "Name of the client for the signature document.",
    taxYear: "Year of the tax document. If taxYear field is not provided, current tax year will be applied by default. TaxYear field accepts only current tax year, current tax year + 1-year, current tax year - 1-year, current tax year - 2-year values.",
    documentType: "Type of the signature document. documentType field accepts only Engagement Letter, Consent Form and Other as per default values in company settings.",
    expiresOn: "Expiry date of signature document. If expiresOn field is not provided, current date + 30 days will be applied by default. expiresOn field accepts only current date and future date.",
    senderSignatureInfoPageNo: "Page number to add the signature controls.",
    senderSignatureInfoSignatureControlsType: "Type of the signature control. Type field accepts only valid type of signature controls.",
    senderSignatureInfoSignatureControlsTop: "Top value (x co-ordinate) of the signature control.",
    senderSignatureInfoSignatureControlsLeft: "Left value (y co-ordinate) of the signature control.",
    senderSignatureInfoSignatureControlsRequired: "Required value for the added signature control. Based on true/false flag the signature control will be required/not required while signing the signature document.",
    senderSignatureInfoSignatureControlsTooltip: "Tooltip for the signature control. Added tooltip will be displayed while hovering on the control.",
    senderSignOption: "Signing option for the sender. If sender sign option is not provided, signing for sender will not be applicable. 0: No sender signing, 1: Sender sign first, 2: Sender sign last.",
    recipientsSignatureInfoEmailAddress: "Email address of the recipients.",
    recipientsSignatureInfoSignatureDataListPageNo: "Page number to add the recipient's signature control.",
    recipientsSignatureInfoSignatureDataListSignatureControlsType: "Type of the signature control. Type field accepts only valid type of signature control (value 1 to 11).",
    recipientsSignatureInfoSignatureDataListSignatureControlsTop: "Top value (x co-ordinate) of the signature control.",
    recipientsSignatureInfoSignatureDataListSignatureControlsLeft: "Left value (y co-ordinate) of the signature control.",
    recipientsSignatureInfoSignatureDataListSignatureControlsRequired: "Required value for the added signature control. Based on true/false flag the signature control will be required/not required while signing the signature document.",
    recipientsSignatureInfoSignatureDataListSignatureControlsTooltip: "Tooltip for the signature control. Added tooltip will be displayed while hovering on the control.",
    isAccessCodeRequired: "Access code authentication. If isAccessCodeRequired field is not provided, no authentication will be applied by default.",
    callBackUri: "Callback URL to notify success/failure of the status of upload and deliver signature document. If callbackUri is not provided, then no response will be posted.",
    correlationId: "A unique identifier given to track the request details."
}

export const SIG_UploadApi_SendForSignature_WithTextIdDescription = {
    correlationId: "A unique identifier given to track the request details.",
    documentName: "Name of the signature document and name should contain .pdf extension in the end, other file formats are not supported.",
    document: "Signature document to be uploaded, it should be converted into Base64 format.",
    clientId: "Unique name to the signature document while uploading.",
    clientName: "Name of the client for the signature document.",
    taxYear: "Year of the Tax Document. If taxYear field is not provided, current tax year will be applied by default. TaxYear field accepts only current tax year, current (tax year + 1) year, current (tax year - 1) year and current (tax year - 2) year values.",
    documentType: "Type of the signature document. documentType field accepts only Engagement Letter, Consent Form and Other as per default values in company setting.",
    expiresOn: "Expiry date of the signature document. If expiresOn field is not provided, current date + 30 days will be applied by default. expiresOn field accepts only current date and future date.",
    senderSignOption: "Signing option for the sender. If sender sign option field is not provided, signing for sender will be not applicable. 0: No sender signing; 1: sender signs first; 2: sender signs last.",
    callBackUri: "Callback URL to notify the success/failure of the status of upload and deliver the signature document. If callBackUri is not provided, then no response will be posted.",
    isAccessCodeRequired: "Access code authentication. If isAccessCodeRequired field is not provided, no authentication will be applied by default.",
    recipientSignatureInfoEmailAddress: "Email Address of the Recipients.",
    recipientSignatureInfoControlsTextId: "Unique Text along with respective signature control to replace with the signature control.",
    recipientSignatureInfoControlsIsRequired: "Required value for the added signature control. Based on true/false flag the signature control will be required/not required while signing the signature document. For valid signature controls, this can be set.",
    recipientSignatureInfoControlsToolTip: "Tooltip for the signature control. Added tooltip will be displayed while hovering on the control. Only for valid signature control, this can be set.",
    senderSignatureInfoTextId: "Unique Text along with respective signature control to replace with the signature control for the Sender.",
    senderSignatureInfoIsRequired: "Required value for the added signature control. Based on true/false flag the signature control will be required/not required while signing the signature document. For valid signature controls, this can be set.",
    senderSignatureInfoToolTip: "Tooltip for the signature control. Added tooltip will be displayed while hovering on the control. Only for valid signature control, this can be set."
}

export const SIG_UploadApis_SetAccessDescriptions = {
    documentId: "Unique Id, to identify the signature.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    userIds: "List of user ids for which access needs to be set."
}

export const SIG_UploadApi_SignatureStatusDescription = {
    clientName: "Name of the Client.",
    clientId: "ClientId, to identify clients and provided while uploading the signature document.",
    sentBy: "Name of the user signature sent by.",
    documentName: "Name of the document.",
    documentType: "Type of the signature document.",
    taxyear: "Tax year of the signature document.",
    deliveredDate: "Date in which the signature document deleted.",
    expiryDate: "Date in which the signature document expired.",
    lastReminderDate: "Date in which the last reminder sent.",
    isArchived: "If signature is archived, then true else false.",
    documentId: "Document Id.",
    emailAddress: "Email address of the recipient.",
    isSigned: "true if document is signed else false.",
    signedOn: "Date in which the document signed on."
}

export const SIG_StatusApi_SignatureStatusDescription = {
    signingId: "Id of signing user.",
    correlationId: "CorrelationId",
    documentId: "Ids of document needs to be signed.",
}

/* SSE */
export const SSE_ComposeMessage_sendMessageDescription = {
    recipients: "Email address of recipients.",
    subject: "Subject of the message.",
    body: "Body of the message.",
    retentionPeriod: "This is retention period.OneDay=0,SevenDays = 1,FourteenDays = 2,TwentyOneDays = 3,ThirtyDays = 4,NinetyDays = 5,OneEightyDays = 6,OneYear = 7,ThreeYears = 8, SevenYears = 9.",
    attachments: "Attachment to be sent.",
    callbackUri: "Callback endpoint URI to post the actual response.",
    correlationId: "A unique identifier Guid that is attached with the request.",
}

export const SSE_DocumentRequestApi_documentRequestDescription = {
    recipients: "Email addresses of recipients.",
    subject: "Subject of the request.",
    templateName: "Name of the template to be used.",
    retentionPeriod: "This is retention period. OneDay=0, SevenDays=1, FourteenDays=2, TwentyOneDays=3, ThirtyDays=4, NinetyDays=5, OneEightyDays=6, OneYear=7, ThreeYears=8, SevenYears=9.",
    notifyOnCompletion: "Whether to notify all recipients on completion."
}

export const SSE_DocumentRequestTemplate_DocumentRequestTemplateDescription = {
    filterTextQuery: "FilterText",
    pageNumberQuery: "Page Number to display the returns. The default value is 1.",
    pageSizeQuery: "Size of the page to display the returns. The default value is 10.",
    sortColumnQuery: "SortColumn. Name = 1, Description = 2, CreatedDate = 3, ModifiedDate = 4, Year = 5, DueDate = 6.",
    sortOrderQuery: "Sort order. Default value is DESC; 0 for ASC, 1 for DESC.",

    documentRequestTemplateId: "Template Id of document request template.",
    name: "Name of the document request template.",
    description: "Description of the document request template.",
    createdDate: "The date when the document request template was created.",
    modifiedDate: "The date when the document request template was last modified.",
    year: "The year associated with the document request template.",
    dueDate: "The due date for the document request template.",
    documentListName: "Name of the document list.",
    documentListDescription: "Description of the document list.",
    documentListCategoryCount: "Count of documentCategory.",
    documentListCategoryId: "Id of the document category.",
    documentListCategoryName: "Name of the document category.",
    documentListCategoryCreatedDate: "The date when the document category was created.",
    documentListCategoryModifiedDate: "The date when the document category was last modified.",
    documentListCategoryCreatedBy: "The user who created the document category."
}

/* SSO */
export const SSO_Archived_APIs_commonDescription = {
    organizerId: "Unique Id, to identify the organizer.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    callbackUri: "callback endpoint URI to post the actual response.",
}

export const SSO_ArchivedAPI_ArchivedOrganizersDescription = {
    clientIDQuery: "ClientId, to identify clients and provided while uploading the organizer document.",
    clientNameQuery: "Name of the Client.",
    taxPayerEmailQuery: "Email Address of the Taxpayer.",
    spouseEmailQuery: "Email Address of the Spouse.",
    archivedByQuery: "Name of the CPA user who archived the organizer document.",
    taxYearQuery: "Tax year of the organizer document. It accepts only current tax year, current (tax year -1) and current (tax year - 2).",
    batchNameQuery: "Name of the Batch if uploaded and delivered through batch.",
    eroQuery: "Name of the Partner or Suite – ERO user.",
    deliveredAfterQuery: "Provides all the organizer documents delivered from the given date. Accepts date format MM/DD/YYYY.By default, the results will be sorted based on DeliveredAfter field and this field supports only for last 30 days.",
    organizerReminderQuery: "Date of the last reminder for the organizer document sent to clients. Accepts date format MM/DD/YYYY.",
    signingReminderQuery: "Date of the last reminder for signature sent to clients. Accepts date format MM/DD/YYYY.",
    signatureStatusQuery: "Signature status of the Engagement Letter.",
    organizerStatusQuery: "Status of the Organizer document.",
    sourceDocumentStatusQuery: "Status of the Source document.",
    sortByQuery: "Used to sort the results based on the given field. By default, sorts by the DeliveredAfter field.",
    sortOrderQuery: "Pass integer value for sort order: 0 for ASC, 1 for DESC.",
    pageNoQuery: "Page number to retrieve the specific page's list of organizer documents. Default is 1.",
    pageSizeQuery: "Number of organizer records per page. Default is 10.",

    organizerId: "Unique Id, to identify the organizer.",
    clientName: "Name of the client.",
    clientID: "Client id.",
    taxpayerEmail: "Email address of taxpayer.",
    spouseEmail: "Email address of spouse.",
    taxYear: "Year of tax.",
    ero: "Name of the ERO.",
    deliveredDate: "Date of delivered.",
    sentBy: "Name of user who send document.",
    batchName: "Name of the batch.",
    organizerReminder: "Date of organizer reminder.",
    signingReminder: "Date of signing reminder.",
    signature_organizer_Status: `This is FormGroupStatus. None = 0, Delivered = 1, PartiallyCompleted = 2, Completed = 3, OrganizerDownloaded = 4, Dropped = 5, ManuallyCompleted = 6, AwaitingESign = 21, PartiallySigned = 22, ESigned = 23, EngagementLetterDownloaded = 24, NA = 25, Reviewed = 26, Declined = 27, ManuallySigned = 28`,
    sourceDocumentStatus: "This is SourceDocumentStatus. None = 0, AwaitingUpload = 1, Uploaded = 2, Downloaded = 3, Completed = 4",
    locationId: "Unique Id, to identify location details.",
    document: "Document- base64 representation of byte array.",
    fileUrl: "Blob Url for file.",
    fileName: "Name of the file."
}

export const SSO_Archived_APIs_ResendAccessLinkDescription = {
    signerGuid: "Signer's unique Guid, to whom resend access link should be sent.",
}

export const SSO_ArchivedAPI_SignerDetailsDescription = {
    organizerId: "Unique Id, to identify the organizer.",

    name: "Name of signer.",
    emailAddress: "Email address of signer.",
    signerGuid: "Guid of signer.",
    signerType: "Undefined = 0, Taxpayer = 1, Spouse = 2, Partner = 3, PartnerShip = 4, ShareHolder = 5, CcRecipient = 6, Delegatee = 7, Controller = 8.",
    signingOrder: "Order of signing.",
    signedOn: "Date on which document signed.",
    isDeceased: "Flag - IsDeceased.",
    signatureStatus: "This is SignatureStatus. None = 0, Esigned = 1, Reviewed = 2, NA = 3",
}

export const SSO_DeliveredAPI_DeliveredOrganizerDescription = {
    clientIDQuery: "ClientId, to identify clients and provided while uploading the organizer document.",
    clientNameQuery: "Name of the Client.",
    taxPayerEmailQuery: "Email Address of the Taxpayer.",
    spouseEmailQuery: "Email Address of the Spouse.",
    sentByQuery: "Name of the CPA user who delivered the organizer document.",
    taxYearQuery: "Tax year of the organizer document. It accepts only current tax year, current (tax year -1) and current (tax year - 2).",
    batchNameQuery: "Name of the Batch if uploaded and delivered through batch.",
    eroQuery: "Name of the Partner or Suite – ERO user.",
    deliveredAfterQuery: "It provides all the list of organizer documents which delivered from the given date. This field accepts only the date format of MM/DD/YYYY. By default, the results will be sorted based on DeliveredAfter field and this field supports only for last 30 days.",
    organizerReminderQuery: "Date in which the last reminder for organizer document was sent to clients. This field accepts only the date format of MM/DD/YYYY.",
    signingReminderQuery: "Date in which the last reminder for signature was sent to clients. This field accepts only the date format of MM/DD/YYYY.",
    signatureStatusQuery: "Signature status of the Engagement Letter.",
    organizerStatusQuery: "Status of the Organizer document.",
    sourceDocumentStatusQuery: "Status of the Source document.",
    sortByQuery: "This field is used to sort the results based on the given field. By default, the results will be sorted based on deliveredAfter field.",
    sortOrderQuery: "This field is used to sort the results by ascending order or by descending order.",
    pageNoQuery: "Page number to get the given page’s list of organizer documents. By default, it will be set to 1.",
    pageSizeQuery: "Size of the page to get the given list of organizer records. By default, it will set to 10 records.",

    organizerId: "Unique Id, to identify the organizer.",
    clientName: "Name of the client.",
    clientID: "Client id.",
    taxpayerEmail: "Email address of taxpayer.",
    spouseEmail: "Email address of spouse.",
    taxYear: "Year of tax.",
    ero: "Name of the ERO.",
    deliveredDate: "Date of delivered.",
    sentBy: "Name of user who send document.",
    batchName: "Name of the batch.",
    organizerReminder: "Date of organizer reminder.",
    signingReminder: "Date of signing reminder.",
    signatureStatus: "This is FormGroupStatus.\nNone = 0,\nDelivered = 1,\nPartiallyCompleted = 2,\nCompleted = 3,\nOrganizerDownloaded = 4,\nDropped = 5,\nManuallyCompleted = 6,\nAwaitingESign = 21,\nPartiallySigned = 22,\nESigned = 23,\nEngagementLetterDownloaded = 24,\nNA = 25,\nReviewed = 26,\nDeclined = 27,\nManuallySigned = 28",
    organizerStatus: "This is FormGroupStatus.\nNone = 0,\nDelivered = 1,\nPartiallyCompleted = 2,\nCompleted = 3,\nOrganizerDownloaded = 4,\nDropped = 5,\nManuallyCompleted = 6,\nAwaitingESign = 21,\nPartiallySigned = 22,\nESigned = 23,\nEngagementLetterDownloaded = 24,\nNA = 25,\nReviewed = 26,\nDeclined = 27,\nManuallySigned = 28",
    sourceDocumentStatus: "This is SourceDocumentStatus.\nNone = 0,\nAwaitingUpload = 1,\nUploaded = 2, Downloaded = 3, Completed = 4",
    locationId: "Unique Id, to identify location details.",
}

export const SSO_DeliveredAPI_SendReminderDescription = {
    organizerId: "Unique Id, to identify the organizer.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    engagementLetterReminder: "Reminder for the Engagement Letter. Provide true if reminder needs to be sent else either provide false or remove this field to not sent the reminder.",
    organizerReminder: "Reminder for the Organizer. Provide true if reminder needs to be sent else either provide false or remove this field to not sent the reminder.",
    sourceDocumentReminder: "Reminder for the Source Document. Provide true if reminder needs to be sent else either provide false or remove this field to not sent the reminder.",
}

export const SSO_DeliveredAPI_SignerDetailsDescription = {
    organizerIdQuery: "Unique Id, to identify the organizer."
}

export const SSO_InProcessAPI_DeleteInProcessOrganizerDescription = {
    organizerId: "Unique Id, to identify the organizer.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    callbackUri: "Actual API operation result will be sent to this URL.",
}

export const SSO_InProcessAPI_GetAllDescription = {
    nameQuery: "Name of the client.",
    clientIdQuery: "ClientId, to identify tax return.",
    eroSignerQuery: "Name of the ERO Signer or Partner.",
    assignedToQuery: "Name of the user assigned to.",
    organizerStatusQuery: "Status of the Organizer Document.",
    uploadedAfterQuery: "It provides all the list of organizer documents which uploaded from the given date. This field accepts only the date format of MM/DD/YYYY. By default, the results will be sorted based on UploadedAfter field, and this field supports only for last 30 days.",
    taxReturnTypeQuery: "Engagement type of the organizer.",
    taxYearQuery: "Tax year of the organizer document. It accepts only current tax year, current (tax year - 1) and current (tax year - 2).",
    pageNoQuery: "Page number to get the given page’s list of organizer documents. By default, it will be set to 1.",
    pageSizeQuery: "Size of the page to get the given list of organizer records. By default, it will set to 10 records.",
    sortOrderQuery: "This field is used to sort the results by ascending order or by descending order. By default, the order is descending. 0 for ASC, 1 for DESC.",
    sortByQuery: "This field is used to sort the results based on the given field. By default, the results will be sorted based on uploadedAfter field.",

    organizerId: "Unique Id.",
    organizerName: "Name of the organizer.",
    clientId: "Client Id",
    eroSigner: "Name of ERO Signer.",
    assignedTo: "Name of assigned user.",
    status: "This is ProcessStatus.\nNone = 0, Uploaded = 1, Ready = 2, Error = 3, Processing = 4, PreparingForDelivery = 5, Delivered = 6, Completed = 7, DeliveryFailed = 8",
    uploadedDate: "Date on which document uploaded.",
    taxReturnType: "This is Engagement type.\nNone = 0, E1040 = 1, E1041 = 5",
    taxYear: "Year of the tax return.",
    locationId: "Unique Id, to identify location details."
}

export const SSO_UploadAPI_BatchDescription = {
    csvFileUri: "Uri where the csv file is uploaded and present. This field supports only .csv file format.",
    zipFileUri: "Uri where the zip file is uploaded and present. This field supports only .zip file format.",
    batchName: "Name of the batch.",
    ero: "ERO or Partner for the client. User needs to give valid userId who is have Partner or Suite – ERO role.",
    taxYear: "Tax year of the organizer document. It accepts only current tax year, current (tax year - 1) and current (tax year - 2).",
    taxSoftware: "This is TaxSoftware. None = -1, ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5.",
    enableEngagementLetter: "This field is similar to the No Engagement Letter field in the Batch Upload window in the user interface. Provide true if no engagement letter and false if engagement letter is included. By default, false will be set to this field. This field will be ignored for the CCH tax software.",
    callbackUri: "callback endpoint URI to post the actual response.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    locationId: "Unique Id, to identify location details."
}

export const SSO_UploadAPI_ProformaDescription = {
    clientId: "ClientId, an unique value to identity clients.",
    eroUser: "ERO or Partner for the client. User needs to give valid UserId who is have Partner or Suite – ERO role.",
    TaxYear: "Tax year of the organizer document. It accepts only current tax year, current (tax year - 1) and current (tax year - 2).",
    taxSoftware: "This is TaxSoftware. None = -1, ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5.",
    taxReturnType: "This is EngagementType. None = 0, E1040 = 1, E1041 = 5.",
    callbackUri: "callback endpoint URI to post the actual response.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    organizer: "Upload Document Model.",
    engagementLetter: "Upload Document Model.",
    isEngagementLetterIncluded: "Provide true if engagement letter is included and false if engagement letter is not included. By default, false will be set to this field.",
}

export const SSO_RecycleBinAPI_GetAllDescription = {
    clientNameQuery: "Name of the client.",
    clientIDQuery: "ClientId, to identify organizer.",
    taxYearQuery: "Tax year of the organizer document. It accepts only current tax year, current (tax year - 1) and current (tax year - 2).",
    eroQuery: "Name of the ERO Signer or Partner.",
    batchNameQuery: "Name of the batch.",
    sentByQuery: "Name of the user sent organizer.",
    deliveredAfterQuery: "Date after which organizer delivered.",
    signatureStatusQuery: "Signature status of organizer document. Available values: AwaitingESign = 0, PartiallySigned = 1, ESigned = 2, EngagementLetterDownloaded = 3, NA = 4, Reviewed = 5, ManuallySigned = 6, PartiallyReviewed = 7",
    organizerStatusQuery: "Status of the Organizer document. Available values: Delivered = 0, PartiallyCompleted = 1, Completed = 2, OrganizerDownloaded = 3, Dropped = 4, ManuallyCompleted = 5, ClosedByFirm = 6, QuestionnaireCompleted = 7",
    sourceDocumentStatusQuery: "Status of the Source document. Available values: None = 0, AwaitingUpload = 1, Uploaded = 2, Downloaded = 3, Completed = 4",
    deletedByQuery: "Name of the user deleted organizer.",
    deletedAfterQuery: "Date after which organizer deleted.",
    sortByQuery: "This field is used to sort the results based on the given field. By default, the results will be sorted based on deliveredAfter field.",
    sortOrderQuery: "Pass integer value referred to sort order 0 for ASC, 1 for DESC.",
    pageNoQuery: "Page number to get the given page’s list of organizer documents. By default, it will be set to 1.",
    pageSizeQuery: "Size of the page to get the given list of organizer records. By default, it will set to 10 records.",

    batchName: "Name of the batch.",
    clientID: "ClientId, to identify organizer.",
    clientName: "Name of the client.",
    deliveredDate: "Date on which organizer delivered.",
    ero: "Name of the ERO Signer or Partner.",
    organizerId: "Unique Id, to identify the organizer.",
    organizerStatus: "Status of the Organizer document. Available values: Delivered = 0, PartiallyCompleted = 1, Completed = 2, OrganizerDownloaded = 3, Dropped = 4, ManuallyCompleted = 5, ClosedByFirm = 6, QuestionnaireCompleted = 7",
    sentBy: "Name of the user sent organizer.",
    signatureStatus: "Signature status of organizer document. Available values: AwaitingESign = 0, PartiallySigned = 1, ESigned = 2, EngagementLetterDownloaded = 3, NA = 4, Reviewed = 5, ManuallySigned = 6, PartiallyReviewed = 7",
    sourceDocumentStatus: "Status of the Source document. Available values: None = 0, AwaitingUpload = 1, Uploaded = 2, Downloaded = 3, Completed = 4",
    taxYear: "Tax year of the organizer document.",
    deletedBy: "Name of the user deleted organizer.",
    deletedDate: "Date on which organizer deleted.",
    locationId: "Office location id.",
}

export const SSO_OrganizerStatusAPI_GetOrganizerStatusDescription = {
    organizerIdQuery: "Unique Id, to identify the organizer.",

    organizerId: "Unique Id, to identify the organizer.",
    clientId: "ClientId, to identify organizer.",
    organizerStatus: "This is FormGroupStatus. None = 0, Delivered = 1, PartiallyCompleted = 2, Completed = 3, OrganizerDownloaded = 4, Dropped = 5, ManuallyCompleted = 6, AwaitingESign = 21, PartiallySigned = 22, ESigned = 23, EngagementLetterDownloaded = 24, NA = 25, Reviewed = 26, Declined = 27, ManuallySigned = 28, PartiallyReviewed = 29",
    lastOrganizerReminder: "Date on which last organizer reminder sent.",
    signatureStatus: "This is FormGroupStatus. None = 0, Delivered = 1, PartiallyCompleted = 2, Completed = 3, OrganizerDownloaded = 4, Dropped = 5, ManuallyCompleted = 6, AwaitingESign = 21, PartiallySigned = 22, ESigned = 23, EngagementLetterDownloaded = 24, NA = 25, Reviewed = 26, Declined = 27, ManuallySigned = 28, PartiallyReviewed = 29",
    lastSignatureReminder: "Date on which last signature reminder sent.",
    sourceDocumentStatus: "This is SourceDocumentStatus. None = 0, AwaitingUpload = 1, Uploaded = 2, Downloaded = 3, Completed = 4",
    isArchived: "If organizer document is archived, then true else false."
}

export const SSO_OrganizerStatusAPI_updateDocumentStatusDescription = {
    documentGuid: "Unique ID.",
    fileNames: "Name of the Organizer.",
    documentType: "This is DocumentType. SourceDocument=0, EngagementLetter=1, Organizer=2",
}

/* GTR */
export const GTR_DeleteDelivered_Description = {
    gatherId: "Unique Id, to identify gather.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    callbackUri: "Actual API operation result will be sent to this URL.",
}

export const GTR_inProcessGather_Description = {
    clientNameQuery: "Name of the client.",
    clientIdQuery: "ClientId, to identify gather.",
    taxYearQuery: "Tax year of the gather document. It accepts only current tax year, current (tax year - 1) and current (tax year - 2).",
    eroSignerQuery: "Name of the ERO Signer or Partner.",
    engagementTypeQuery: 'For 1040 Engagement pass value as 1, For 1065 Engagement pass value as 2, For 1120 Engagement pass value as 3, For 1120S Engagement pass value as 4, For 1041 Engagement pass value as 5, For 1040NR Engagement pass value as 6, For 990 Engagement pass value as 7, For 990PF Engagement pass value as 8, For 990EZ Engagement pass value as 9.',
    documentStatusQuery: "Status of the Gather document.",
    pageSizeQuery: "Size of the page to get the given list of gather records. By default, it will set to 10 records.",
    pageNumberQuery: "Page number to get the given page’s list of gather documents. By default, it will be set to 1.",
    sortByQuery: "This field is used to sort the results based on the given field. By default, the results will be sorted based on uploadedAfter field.",
    sortOrderQuery: "Pass integer value referred to sort order 0 for ASC, 1 for DESC.",

    clientName: 'Name of the client.',
    clientId: 'ClientId, to identify gather.',
    eroSigner: 'Name of the ERO Signer or Partner.',
    officeLocation: 'office locationId.',
    assignedTo: 'Name of the user assigned to.',
    status: 'Status of document.',
    date: 'Date of the document.',
    engagementType: 'This is Engagement type. None = 0, 1040 = 1, 1065 = 2, 1120 = 3, 1120S = 4, 1041 = 5, 1040NR = 6, 990 = 7, 990PF = 8, 990EZ = 9.',
    taxYear: 'Tax year of the gather document.',
    gatherId: 'Unique Id, to identify gather.',
}
/* SSR */

export const SSR_DeliveredAPI_GetAccessLinkDescription = {
    taxReturnIdQuery: "Unique Id, to identify tax return.",

    clientId: "ClientId, to identify tax return.",
    clientName: "Name of the client.",
    taxYear: "Year of the tax return.",
    signatureStatus: "This is Signature Status type. ESigned = 1, ManuallySigned = 2, Uploaded = 3, AwaitingESign = 4, AwaitingUpload = 5, Locked = 6, MailOrFax = 7, SignedAndESigned = 8, DeliveredToTaxCaddy = 10, TaxCaddyDeliveryFailed = 16, AlternateDelivery = 17, DownloadingFailed = 18, AlternateAndUploaded = 19, PartiallySigned = 20",
    accessLinkTaxpayer: "Taxpayer access link.",
    accessLinkSpouse: "Spouse access link.",
}

export const SSR_SecondBaseRequestDescription = {
    taxReturnId: "Unique Id, to identify tax return.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    callbackUri: "Actual API operation result will be sent to this URL.",
}

export const SSR_BaseFalseRequestBodyDescription = {
    documents: "List of Tax Returns in Base64 format.",
    fileURLs: "List of file URLs, which need to be uploaded.",
    correlationId: "A unique identifier Guid that is attached with the request.",
}

export const SSR_DeliveredAPI_DeliveredReturnsDescription = {
    clientIdQuery: "ClientId, to identify tax return.",
    clientNameQuery: "Name of the client.",
    taxYearQuery: "Year of the tax return.",
    eroQuery: "Name of the ERO Signer or Partner.",
    signatureStatusQuery: "1 for ESigned, 2 for ManuallySigned, 3 for Uploaded, 4 for AwaitingESign, 5 for AwaitingUpload, 8 for SignedAndESigned, 10 for DeliveredToTaxCaddy, 16 for TaxCaddyDeliveryFailed, 17 for AlternateDelivery, 19 for AlternateAndUploaded, 20 for PartiallySigned, 21 for SignatureStampingFailed, 22 for ESignedInOffice , 23 for AwaitingDraftReview, 24 for DraftApproved, 25 for DraftNotApproved, 26 for FinalReturnCopyCreated.",
    DraftStatusQuery: "1 for Draft Return, 2 for Final Return",
    engagementTypeQuery: "For 1040 Engagement pass value as '1', For 1065 Engagement pass value as '2', For 1120 Engagement pass value as '3', For 1120S Engagement pass value as '4', For 1041 Engagement pass value as '5', For 1040NR Engagement pass value as '6', For 990 Engagement pass value as '7', For 990PF Engagement pass value as '8', For 990EZ Engagement pass value as '9'.",
    deliveredAfterQuery: "Delivered after date.",
    pageSizeQuery: "Size of the page to display the returns. The default value is 10.",
    pageNumberQuery: "Page Number to display the returns. The default value is 1.",
    sortByQuery: "Pass integer value referred to sort option: 0 for Name, 1 for Client Id, 2 for ERO, 3 for Signature Status, 4 for Engagement Type, 5 for Tax Year, 6 for Delivered Date (default value).",
    sortOrderQuery: "Pass integer value referred to sort order: 0 for ASC, 1 for DESC.",

    taxReturnId: "Unique Id, to identify tax return.",
    clientId: "ClientId, to identity tax return.",
    clientName: "Name of the client.",
    eroSignerFirstName: "First name of ERO Signer.",
    eroSignerLastName: "Last name of ERO Signer.",
    taxYear: "Year of the tax return.",
    taxSoftware: "This is Tax Software type. ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5.",
    engagementType: "This is Engagement type. None = 0, 1040 = 1, 1065 = 2, 1120 = 3, 1120S = 4, 1041 = 5, 1040NR = 6, 990 = 7, 990PF = 8, 990EZ = 9.",
    signatureStatus: "This is Signature Status type. ESigned = 1, ManuallySigned = 2, Uploaded = 3, AwaitingESign = 4, AwaitingUpload = 5, Locked = 6, MailOrFax = 7, SignedAndESigned = 8, DeliveredToTaxCaddy = 10, TaxCaddyDeliveryFailed = 16, AlternateDelivery = 17, DownloadingFailed = 18, AlternateAndUploaded = 19, PartiallySigned = 20, SignatureStampingFailed = 21, ESignedInOffice  = 22, AwaitingDraftReview = 23, DraftApproved = 24, DraftNotApproved = 25, FinalReturnCopyCreated = 26 .",
    draftStatus: "This is Draft Status type. Draft Return = 1, Final Return = 2",
    downloadStatus: "This is Download status type. ToBeDownloaded = 0, Downloaded = 1.",
    documentFilingType: "This is Filing type. None = 0, EFiled = 1, Both = 2, PaperFile = 3.",
    lastReminderDate: "Date on which last reminder has been sent.",
    deliveredOn: "Date on which document was delivered.",
    deletionDate: "Retention period of the return.",
    locationId: "Unique Id, to identify location details.",
    groupName: "Group name of the group.",
}

export const SSR_DeliveredAPI_GetEFileFormsDescription = {
    clientId: "ClientId, to identity tax return.",
    clientName: "Name of the client.",
    engagementType: "This is Engagement type. None = 0, 1040 = 1, 1065 = 2, 1120 = 3, 1120S = 4, 1041 = 5, 1040NR = 6, 990 = 7, 990PF = 8, 990EZ = 9.",
    formNames: "List of form names.",
}

export const SSR_DeliveredAPI_ResendAccessLinkDescription = {
    signerGuid: "Signers unique Guid, to which resend access link should be sent.",
}

export const SSR_DeliveredAPI_SignatureStatusDescription = {
    signStatus: "This is Signature Status type. ESigned = 1, ManuallySigned = 2, Uploaded = 3, AwaitingESign = 4, AwaitingUpload = 5, Locked = 6, MailOrFax = 7, SignedAndESigned = 8, DeliveredToTaxCaddy = 10, TaxCaddyDeliveryFailed = 16, AlternateDelivery = 17, DownloadingFailed = 18, AlternateAndUploaded = 19, PartiallySigned = 20.",
    documentStatus: "It is Document Status Type. UPLOADED = 1, ERROR = 2, READY = 3, PROCESSING = 4, REVIEW = 5, USERSIGNED = 6, DELIVERED = 7, APPROVEDFORDELIVERY = 8, PREPARINGFORDELIVERY = 9, DELIVERYFAILED = 10, NONSUPPORTED = 11, RECALLED = 12, DELETED = 13, REPROCESSING = 14, DELIVEREDTOTAXCADDY = 15, TAXCADDYDELIVERYFAILED = 16, DUPLICATE = 17, DOWNLOADPDF = 18, DOWNLOADINGFAILED = 19, PREPARINGFORPDFDOWNLOAD = 20, TOBEREPROCESSED = 21, READYFORDELIVERY = 22.",
    signMode: "This is Signature type. None = 0, ESign = 1, ESignWhenAllIncludedReturnsAllowed = 2, ManualSign = 3.",
}

export const SSR_DeliveredAPI_SignerInfoDescription = {
    documentId: "Unique document Id for the signer.",
    signer: "Email Address of the signer.",
    isSigned: "Returns true if document is signed by signer else false.",
    signedOn: "The date on which document is signed by the signer. null value is present if signer not completed not signed.",
    signerType: "Undefined = 0, Taxpayer = 1, Spouse = 2, Partner = 3, PartnerShip = 4, ShareHolder = 5, CcRecipient = 6, Delegatee = 7, Controller = 8.",
    order: "Signing order in which document should be signed by the signers.",
    name: "Full name of Signer.",
    signerGuid: "A unique identifier Guid that is assigned to the user.",
    isDeceased: "Returns true if signer is deceased else false.",
}

export const SSR_ArchivedReturnAPI_GetAccessLinkDescription = {
    taxReturnIdQuery: 'Unique Id, to identify tax return.',

    clientId: 'ClientId, to identify the tax return.',
    clientName: 'Name of the client.',
    taxYear: 'Year of the tax return.',
    signatureStatus: 'This is the Signature Status type. ESigned = 1, ManuallySigned = 2, Uploaded = 3, AwaitingESign = 4, AwaitingUpload = 5, Locked = 6, MailOrFax = 7, SignedAndESigned = 8, DeliveredToTaxCaddy = 10, TaxCaddyDeliveryFailed = 16, AlternateDelivery = 17, DownloadingFailed = 18, AlternateAndUploaded = 19, PartiallySigned = 20.',
    accessLinkTaxpayer: 'Taxpayer access link.',
    accessLinkSpouse: 'Spouse access link.',
}

export const SSR_ArchivedReturn_ArchivedReturnsDescription = {
    clientIdQuery: "ClientId, to identify tax return.",
    clientNameQuery: "Name of the client.",
    taxYearQuery: "Year of the tax return.",
    eroQuery: "Name of the ERO Signer or Partner.",
    signatureStatusQuery: "1 for ESigned, 2 for ManuallySigned, 3 for Uploaded, 4 for AwaitingESign, 5 for AwaitingUpload, 8 for SignedAndESigned, 10 for DeliveredToTaxCaddy, 16 for TaxCaddyDeliveryFailed, 17 for AlternateDelivery, 19 for AlternateAndUploaded, 20 for PartiallySigned, 21 for SignatureStampingFailed, 22 for ESignedInOffice , 23 for AwaitingDraftReview, 24 for DraftApproved, 25 for DraftNotApproved, 26 for FinalReturnCopyCreated.",
    engagementTypeQuery: "For 1040 Engagement pass value as '1', For 1065 Engagement pass value as '2', For 1120 Engagement pass value as '3', For 1120S Engagement pass value as '4', For 1041 Engagement pass value as '5', For 1040NR Engagement pass value as '6', For 990 Engagement pass value as '7', For 990PF Engagement pass value as '8', For 990EZ Engagement pass value as '9'.",
    deliveredAfterQuery: "Delivered after date.",
    pageSizeQuery: "Default size is 10.",
    pageNumberQuery: "Default page number is always 1.",
    sortByQuery: "Pass integer value referred to sort option: 0 for Name, 1 for Client Id, 2 for ERO, 3 for Signature Status, 4 for Engagement Type, 5 for Tax Year, 6 for Delivered Date (default if no value selected).",
    sortOrderQuery: "Pass integer value referred to sort order: 0 for ASC, 1 for DESC.",

    taxReturnId: "Unique Id, to identify tax return.",
    clientId: "Client Id, to identify tax return.",
    clientName: "Name of the client.",
    eroSignerFirstName: "First name of ERO Signer or Partner.",
    eroSignerLastName: "Last name of ERO Signer or Partner.",
    taxYear: "Year of the tax return.",
    taxSoftware: "This is Tax Software type. ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5.",
    engagementType: "This is Engagement type. None = 0, 1040 = 1, 1065 = 2, 1120 = 3, 1120S = 4, 1041 = 5, 1040NR = 6, 990 = 7, 990PF = 8, 990EZ = 9.",
    signatureStatus: "This is Signature Status type. ESigned = 1, ManuallySigned = 2, Uploaded = 3, AwaitingESign = 4, AwaitingUpload = 5, Locked = 6, MailOrFax = 7, SignedAndESigned = 8, DeliveredToTaxCaddy = 10, TaxCaddyDeliveryFailed = 16, AlternateDelivery = 17, DownloadingFailed = 18, AlternateAndUploaded = 19, PartiallySigned = 20, SignatureStampingFailed = 21, ESignedInOffice  = 22, AwaitingDraftReview = 23, DraftApproved = 24, DraftNotApproved = 25, FinalReturnCopyCreated = 26.",
    downloadStatus: "This is Download status type. ToBeDownloaded = 0, Downloaded = 1.",
    documentFilingType: "This is Filing type. None = 0, EFiled = 1, Both = 2, PaperFile = 3.",
    lastReminderDate: "Date on which last reminder has been sent.",
    deliveredOn: "Date on which document was delivered.",
    deletionDate: "Retention period of the return.",
    locationId: "Unique Id, to identify location details.",
    groupName: "Group name of the group.",
}

export const SSR_ArchivedReturnAPI_SignatureStatusDescription = {
    taxReturnIdQuery: 'Unique Id, to identify tax return.',

    signStatus: "This is Signature Status type. ESigned = 1, ManuallySigned = 2, Uploaded = 3, AwaitingESign = 4, AwaitingUpload = 5, Locked = 6, MailOrFax = 7, SignedAndESigned = 8, DeliveredToTaxCaddy = 10, TaxCaddyDeliveryFailed = 16, AlternateDelivery = 17, DownloadingFailed = 18, AlternateAndUploaded = 19, PartiallySigned = 20.",
    documentStatus: "It is Document Status Type. UPLOADED = 1, ERROR = 2, READY = 3, PROCESSING = 4, REVIEW = 5, USERSIGNED = 6, DELIVERED = 7, APPROVEDFORDELIVERY = 8, PREPARINGFORDELIVERY = 9, DELIVERYFAILED = 10, NONSUPPORTED = 11, RECALLED = 12, DELETED = 13, REPROCESSING = 14, DELIVEREDTOTAXCADDY = 15, TAXCADDYDELIVERYFAILED = 16, DUPLICATE = 17, DOWNLOADPDF = 18, DOWNLOADINGFAILED = 19, PREPARINGFORPDFDOWNLOAD = 20, TOBEREPROCESSED = 21, READYFORDELIVERY = 22.",
    signMode: "This is Signature type. None = 0, ESign = 1, ESignWhenAllIncludedReturnsAllowed = 2, ManualSign = 3.",
}

export const SSR_ArchivedReturnAPI_SignerInfoDescription = {
    documentId: "Unique document Id for the signer",
    signer: "Email address of the signer",
    isSigned: "Return true if document is signed by signer else false",
    signedOn: "The date on which document is signed by the signer. null value is present if signer has not signed",
    signerType: "SignerType - Undefined = 0, Taxpayer = 1, Spouse = 2, Partner = 3, Partnership = 4, Shareholder = 5, CcRecipient = 6, Delegatee = 7, Controller = 8",
    order: "Signing order in which document should be signed by the signers",
    name: "Full name of Signer",
    signerGuid: "A unique identifier Guid that is assigned to the user",
    isDeceased: "Returns true if signer is deceased else false",
}

export const SSR_InProcessAPI_assignReturnDescription = {
    taxReturnIds: "List of unique Ids, to identify tax returns.",
    userId: "User id, to whom returns will be assigned.",
}

export const SSR_InProcessAPI_ChangeDocumentStatusDescription = {
    documentStatus: "It is Document Status Type. UPLOADED = 1, ERROR = 2, READY = 3, PROCESSING = 4, REVIEW = 5, USERSIGNED = 6, DELIVERED = 7, APPROVEDFORDELIVERY = 8, PREPARINGFORDELIVERY = 9, DELIVERYFAILED = 10, NONSUPPORTED = 11, RECALLED = 12, DELETED = 13, REPROCESSING = 14, DELIVEREDTOTAXCADDY = 15, TAXCADDYDELIVERYFAILED = 16, DUPLICATE = 17, DOWNLOADPDF = 18, DOWNLOADINGFAILED = 19, PREPARINGFORPDFDOWNLOAD = 20, TOBEREPROCESSED = 21, READYFORDELIVERY = 22",
}

export const SSR_InProcessAPI_GetAllDescription = {
    ClientIdQuery: "ClientId, to identity tax return.",
    ClientNameQuery: "Name of the client.",
    TaxYearQuery: "Year of the tax return.",
    EROQuery: "Name of the ERO Signer or Partner.",
    AssignedToQuery: "Name of the User to whom the tax return is assigned to.",
    DocumentStatusQuery: "1 for UPLOADED, 2 for ERROR, 3 for READY, 4 for PROCESSING, 5 for REVIEW, 8 for APPROVEDFORDELIVERY, 9 for PREPARINGFORDELIVERY, 10 for DELIVERYFAILED, 11 for NONSUPPORTED, 12 for RECALLED, 13 for DELETED, 14 for REPROCESSING, 16 for TAXCADDYDELIVERYFAILED, 17 for DUPLICATE, 19 for DOWNLOADINGFAILED, 20 for PREPARINGFORPDFDOWNLOAD, 21 for TOBEREPROCESSED,25 for DRAFTAPPROVEDREADYTOFINALIZE",
    DraftStatusQuery: "1 for Draft Return, 2 for Final Return",
    EngagementTypeQuery: "For 1040 Engagement pass value as '1', For 1065 Engagement pass value as '2' For 1120 Engagement pass value as '3' For 1120S Engagement pass value as '4' For 1041 Engagement pass value as '5' For 1040NR Engagement pass value as '6' For 990 Engagement pass value as '7' For 990PF Engagement pass value as '8' For 990EZ Engagement pass value as '9'",
    UploadedAfterQuery: "Returns Uploaded after the specified date. Supports only for last 30 days and No default value.",
    PageSizeQuery: "Size of the page to display the returns. The default value is 10.",
    PageNumberQuery: "Page Number to display the returns. The default value is 1.",
    SortByQuery: "Returns the results based on sorting attribute. The default value is 7 and results will be displayed based on uploaded date attribute. Name = 0, Client Id = 1, ERO = 2, Assigned To = 3, Signature Status = 4, Engagement Type = 5, Tax Year = 6, Uploaded Date = 7, Draft Status = 8",
    SortOrderQuery: "Sort order default value is DESC 0 for ASC, 1 for DESC",

    taxReturnId: "Unique Id, to identify tax return.",
    clientId: "Client Id",
    clientName: "Name of the client.",
    taxYear: "Year of the tax return.",
    assignedToFirstName: "First name of user to whom return is assigned.",
    assignedToLastName: "Last name of user to whom return is assigned.",
    eroSignerFirstName: "First name of ERO Signer.",
    eroSignerLastName: "Last name of ERO Signer.",
    documentStatus: "It is Document Status Type. UPLOADED = 1, ERROR = 2, READY = 3, PROCESSING = 4, REVIEW = 5, USERSIGNED = 6, DELIVERED = 7, APPROVEDFORDELIVERY = 8, PREPARINGFORDELIVERY = 9, DELIVERYFAILED = 10, NONSUPPORTED = 11, RECALLED = 12, DELETED = 13, REPROCESSING = 14, DELIVEREDTOTAXCADDY = 15, TAXCADDYDELIVERYFAILED = 16, DUPLICATE = 17, DOWNLOADPDF = 18, DOWNLOADINGFAILED = 19, PREPARINGFORPDFDOWNLOAD = 20, TOBEREPROCESSED = 21, READYFORDELIVERY = 22, DRAFTAPPROVEDREADYTOFINALIZE = 25",
    engagementType: "This is Engagement type. None = 0, 1040 = 1, 1065 = 2, 1120 = 3, 1120S = 4, 1041 = 5, 1040NR = 6, 990 = 7, 990PF = 8, 990EZ = 9",
    taxSoftware: "This is Tax Software type. ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5",
    uploadedOn: "Date on which return is uploaded.",
    locationId: "Unique Id, to identify location details.",
    draftStatus: "This is Draft Status type. Draft Return = 1, Final Return = 2",
    groupName: "Group name of the group.",
}

export const SSR_RecycleBin_GetAllDescription = {
    ClientNameQuery: "Name of the client.",
    ClientIdQuery: "ClientId, to identity tax return.",
    TaxYearQuery: "Year of the tax return.",
    EngagementTypeQuery: "For 1040 Engagement pass value as '1', For 1065 Engagement pass value as '2' For 1120 Engagement pass value as '3' For 1120S Engagement pass value as '4' For 1041 Engagement pass value as '5' For 1040NR Engagement pass value as '6' For 990 Engagement pass value as '7' For 990PF Engagement pass value as '8' For 990EZ Engagement pass value as '9'.",
    EROQuery: "Name of the ERO Signer or Partner.",
    SentByQuery: "Name of the user sent return.",
    DeliveredAfterQuery: "Date after which returns delivered.",
    StatusQuery: "0 for None, 1 for ESigned, 2 for ManuallySigned, 3 for Uploaded, 4 for AwaitingESign, 5 for AwaitingUpload, 6 for Locked, 7 for MailOrFax, 8 for SignedAndESigned, 10 for DeliveredToTaxCaddy, 16 for TaxCaddyDeliveryFailed, 17 for AlternateDelivery, 18 for DownloadingFailed, 19 for AlternateAndUploaded, 20 for PartiallySigned, 21 for SignatureStampingFailed, 22 for ESignedInOffice , 23 for AwaitingDraftReview, 24 for DraftApproved, 25 for DraftNotApproved, 26 for FinalReturnCopyCreated. .",
    DeletedOnQuery: "Date on which return is deleted.",
    DeletedByQuery: "Name of user which deleted return.",
    PageNumberQuery: "Page Number to display the returns. The default value is 1.",
    PageSizeQuery: "Size of the page to display the returns. The default value is 10.",
    SortByQuery: "Returns the results based on sorting attribute. The default value is 6 and results will be displayed based on delivered date attribute. ClientName=0, ClientID=1, TaxReturnType=2, Partner=3, TaxYear=4, SentBy=5, DeliveredOn=6, SignatureStatus=7, DeletedOn=8, DeletedBy=9.",
    SortOrderQuery: "Sort order default value is DESC 0 for ASC, 1 for DESC.",

    id: "Unique Id, to identify record in database.",
    taxReturnId: "Unique Id, to identify tax return.",
    clientName: "Name of the client.",
    clientId: "Client Id",
    eroSignerFirstName: "First name of ERO Signer.",
    eroSignerLastName: "Last name of ERO Signer.",
    engagementType: "This is Engagement type. None = 0, 1040 = 1, 1065 = 2, 1120 = 3, 1120S = 4, 1041 = 5, 1040NR = 6, 990 = 7, 990PF = 8, 990EZ = 9",
    taxYear: "Year of the tax return.",
    deliveredOn: "Date on which return is delivered.",
    deliveredByFirstName: "First name of user delivered return.",
    deliveredByLastName: "Last Name of user delivered return.",
    deletedOn: "Date on which return is deleted.",
    deletedByFirstName: "First name of user deleted return.",
    deletedByLastName: "Last Name of user deleted return.",
    signatureStatus: "This is Signature Status. None=0, ESigned = 1, ManuallySigned = 2, Uploaded = 3, AwaitingESign = 4, AwaitingUpload = 5, Locked = 6, MailOrFax = 7, SignedAndESigned = 8, DeliveredToTaxCaddy = 10, TaxCaddyDeliveryFailed = 16, AlternateDelivery = 17, DownloadingFailed = 18, AlternateAndUploaded = 19, PartiallySigned = 20, SignatureStampingFailed = 21, ESignedInOffice  = 22, AwaitingDraftReview = 23, DraftApproved = 24, DraftNotApproved = 25, FinalReturnCopyCreated = 26 .",
    locationId: "Unique Id, to identify location details.",
    groupName: "Group name of the group.",
}

export const SSR_ReturnsAPI_AppendDescription = {
    taxReturnId: "Unique Id, to identify tax return.",
}

export const SSR_ReturnsAPI_FetchReturnDescription = {
    taxReturnId: "Unique Id, to identify tax return.",
    taxYear: "Year of the tax return.",
    clientId: "ClientId, to identity tax return.",
    clientName: "Name of the client.",
    signatureStatus: "Signature Status.",
    engagementType: "Engagement type.",
    isArchived: "if true, then return is archived",
    draftStatus: "This is Draft Status type. Draft Return = 1, Final Return = 2",
    groupName: "Group name of the group.",
}

export const SSR_ReturnsAPI_PartialUploadDescription = {
    rid: "This is an optional field provided for the API clients to include any type of unique id in the request, for any client specific purposes. The value sent as part of the request will be returned back in the response.",
    clientId: "This is the ClientId which would appear under the column Client Id in SSR in All Assignments or My Assignments screen.",
    taxSoftware: "This is Taxreturn software type, ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5"
}

export const SSR_Returns_RecognizeReturnDescription = {
    correlationId: "A unique identifier Guid that is attached with the request.",

}

export const SSR_ReturnsAPI_SetAccessDescription = {
    assignedTo: "List of user ids.",
}

export const SSR_ReturnsAPI_UnRecognizedReturnDescription = {
    rid: "This is an optional field passed while uploading returns.",
    clientId: "ClientId used while uploading the return.",
    uploadedDate: "Uploaded date of the tax return.",
    taxSoftware: "This is Taxreturn software type, ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5",
    taxReturnId: "Unique Id, to identify tax return."
}

export const SSR_ReturnsAPI_UploadDescription = {
    documents: "List of Tax Returns in Base64 format.",
    fileURLs: "List of file URLs, which need to be uploaded.",
    rid: "This is an optional field provided for the API clients to include any type of unique id in the request, for any client specific purposes.The value sent as part of the request will be returned back in the response.",
    clientId: "This is the ClientId which would appear under the column Client Id in SSR in All Assignments or My Assignments screen.",
    taxSoftware: "This is Taxreturn software type, ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5.",
    correlationId: "A unique identifier Guid that is attached with the request.",
    callbackUri: "Actual API operation result will be sent to this URL. Click here to check Response Model.",
    delayRecognition: "If set to true , file recognition will not be triggered on upload and the return will not appear in ssr.if set false file recognition will be triggered on upload of return.",
}

export const SSR_ReturnsAPI_UploadedDescription = {
    rid: "Id passed during upload request.",
    clientId: "Id to uniquely identify client.",
    isRecognized: "Tax return recognized or not.",
    CreatedDate: "Document uploaded date.",
    RecognitionDate: "Date on which document got recognized.",
    taxSoftware: "This is Taxreturn software type, ProSystems = 0, UltraTax = 1, GoSystem = 2, UltraTaxM18 = 3, Lacerte = 4, Drake = 5.",
    delayRecognition: "This field indicates whether recognition should be delayed.",
    taxReturnId: "Unique Id, to identify tax return."

}

export const SSR_ReturnStatus_SetDownloadStatusDescription = {
    taxReturnId: 'Unique id generated by the SSR for the tax return uploaded.'
}


/* SUITE : CLIENT MANAGEMENT */
const clientOrSpouseModel = {
    Name: "Name of the client/spouse.",
    EmailAddress: "Email address of the client/spouse.",
    MobileNumber: "Mobile number of the client/spouse.",
    CountryCode: "Country code of the client/spouse.",
    Dob: "Date of birth of the client/spouse.",
    SsnOrEin: "SSN/EIN of the client/spouse.",
}

const commonClientManagementDescriptions = {
    ero: "ERO or Partner associated with the client.",
    mfj: "Status of 'Married Filing Jointly'.",
    clientId: "ClientId, to identify Client.",
    type: "This is ClientType.None = 0, Taxpayer = 1, Entity = 2",
    defaultSignFirst: "Default setting for first sign for the client.",
    locationId: "Office locationId assigned to client.",
}

export const addClientDescriptions = {
    ...commonClientManagementDescriptions,
    ...clientOrSpouseModel,
}

export const getAllClientsDescriptions = {
    filterTextQuery: "Search records based on ClientId, Name, Email address and SSN_Or_EIN of Client or Spouse.",
    pageSizeQuery: "Size of the page to display the returns. The default value is 10.",
    pageNumberQuery: "Page Number to display the returns. The default value is 1.",
    sortByQuery: "Returns the results based on sorting attribute.The default value is 0 and results will be displayed based on ClientId attribute.clientId = 0, Name = 1, EmailAddress = 2, SpouseName = 3, SpouseEmailAddress = 4, LocationName = 5",
    sortOrderQuery: "Sort order default value is ASC.0 for ASC,1 for DESC",
}

export const getAllClientsResponseDescriptions = {
    uniqueId: "Unique Id, to identify record in database.",
    clientId: commonClientManagementDescriptions.clientId,
    ...clientOrSpouseModel,
    type: commonClientManagementDescriptions.type,
    ero: commonClientManagementDescriptions.ero,
    mfj: commonClientManagementDescriptions.mfj,
    locationId: commonClientManagementDescriptions.locationId,
}

export const deleteClientRequestParameterDescriptions = {
    uniqueIdQuery: "Unique ID of client that you want to delete."
}

export const editClientDescriptions = {
    uniqueId: "Unique Id, to identify record in database.",
    clientId: commonClientManagementDescriptions.clientId,
    type: commonClientManagementDescriptions.type,
    ero: commonClientManagementDescriptions.ero,
    mfj: commonClientManagementDescriptions.mfj,
    defaultSignFirst: "Default first setting.",
    locationId: commonClientManagementDescriptions.locationId,
    ...clientOrSpouseModel,
}

export const clientUploadCSVDescriptions = {
    document: "Document representation in base64 string format.",
    fileName: "File name.",
    callbackUri: "Actual API operation result will be sent to this URL.",
    correlationId: "A unique identifier Guid that is attached with the request."
}

/* SUITE: OFFICE LOCATION */
const officeLocationModel = {
    locationId: "Office locationId.",
    isPrimary: "Shows office location is primary or not.",
    name: "Name of office location.",
    countryCode: "Country code of office location.",
    phone: "Phone number of office location.",
    address1: "Address 1 (Apt, suite etc) of office location.",
    address2: "address 2 (Street address) of office location.",
    city: "City of office location.",
    zip: "Zip of office location.",
    fax: "Fax of office location.",
    website: "Website of office location.",
    state: "State of office location."
}

export const getAllLocationsDescriptions = {
    filterTextQuery: "FilterText - It is used to search records based on Name, Address, City and Website.",
    pageNumberQuery: "Default page number is always 1.",
    ...officeLocationModel
}

export const locationByIdDescriptions = {
    locationIdQuery: "Office location id.",
    ...officeLocationModel
}

/* SUITE: USER MANAGEMENT */
const userManagementCommonParameters = {
    firstName: "First name of user.",
    lastName: "Last name of user.",
    emailAddress: "Email address of the user.",
    phone: "Phone of the user.",
    extension: "Extension of the user.",
    fax: "Fax of the user.",
    mobileNumber: "Mobile number of the user.",
    countryCode: "Country code of the user.",
    ptin: "PTIN of the user.",
    userGroups: "User group ids (comma separated) that needs to be assigned to the user.",
    officeLocations: "Office location ids (comma separated) that needs to be assigned to the user.",
    isMFAEnabled: "Flag to set MFA settings for user.",
}

export const addUserDescriptions = {
    ...userManagementCommonParameters,
}

export const getAllUsersDescriptions = {
    nameQuery: "Name of the user.",
    emailQuery: "Email address of user.",
    pageSizeQuery: "Size of the page to display the returns. The default value is 10.",
    pageNumberQuery: "Page Number to display the returns. The default value is 1.",
    sortByQuery: "Returns the results based on sorting attribute. The default value is 0 and results will be displayed based on first name attribute.First Name = 0, Last Name = 1, Email = 2",
    sortOrderQuery: "Sort order default value is ASC: 0 for ASC,1 for DESC",
    firstName: userManagementCommonParameters.firstName,
    lastName: userManagementCommonParameters.lastName,
    emailAddress: userManagementCommonParameters.emailAddress,
    phone: userManagementCommonParameters.phone,
    extension: userManagementCommonParameters.extension,
    fax: userManagementCommonParameters.fax,
    mobileNumber: userManagementCommonParameters.mobileNumber,
    countryCode: userManagementCommonParameters.countryCode,
    ptin: userManagementCommonParameters.ptin,
    isMFAEnabled: userManagementCommonParameters.isMFAEnabled,
    userId: "UserId of the user.",
    groupId: "GroupId of the group.",
    groupName: "Group name of the group.",
    locationId: "Office locationId.",
    locationName: "Name of office location.",
    isPrimary: "Boolean. True if office location is primary otherwise false."
}

export const getAllUserGroupsDescriptions = {
    groupId: "Group id.",
    groupName: "Name of the group.",
    groupDescription: "Description of the group.",
    isDefault: "Is Default.",
    roleId: "Role id.",
    roleName: "Name of the role.",
    products: "This is ProductType.None = 0, Safesend Returns = 1, Safesend Signatures = 2,Safesend Mail Merge = 3, Safesend Organizers = 4, Safesend Extensions = 5, Safesend Exchange = 6, SSSuite Portal Client = 1001",
}

export const editUserDescriptions = {
    userId: 'UserId of the user.',
    ...userManagementCommonParameters
}

export const deleteUserDescriptions = {
    userIdQuery: "User id of user to be deleted."
}